import { useContext, useState } from 'react';
import { Checkbox } from 'baseui/checkbox';
import { ProjectContext } from '../../ProjectApp/context';
export const FlagCheckbox = ({
  value,
  label,
  flagProp,
  disabled
}) => {
  const [isChecked, setIsChecked] = useState(value);
  const {
    editFlags
  } = useContext(ProjectContext);
  return <Checkbox checked={isChecked} disabled={disabled} overrides={{
    Input: {
      props: {
        'data-testid': `flag-${flagProp}`
      }
    }
  }} onChange={() => {
    editFlags({
      [flagProp]: !value
    });
    setIsChecked(!value);
  }}>
      {label}
    </Checkbox>;
};